module.exports = __webpack_public_path__ + "static/img/lifestyle_02.876ccda7.jpg";